import { animate, style, transition, trigger } from '@angular/animations';
import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
} from '@angular/core';
import {
  Datastore,
  DatastoreDocument,
  RequestStatus,
} from '@freelancer/datastore';
import {
  Banner,
  BannersCollection,
  BannerType,
  ProfileViewUsersCollection,
} from '@freelancer/datastore/collections';
import * as Rx from 'rxjs';
import { map } from 'rxjs/operators';

enum BannerId {
  CORPORATE_UPSELL = 'corporate_upsell',
}

@Component({
  selector: 'app-user-profile-banner',
  template: `
    <fl-bit
      *ngIf="banner$ | flAsync as banner"
      [ngSwitch]="banner.id"
      [@showElement]
    >
      <app-corporate-upsell-banner
        *ngSwitchCase="BannerId.CORPORATE_UPSELL"
        bodyText="Please renew your subscription to continue using your corporate profile and other corporate benefits."
        i18n-bodyText="Expired Corporate upsell banner body text"
        buttonLabel="Continue with Corporate"
        i18n-buttonLabel="Expired Corporate upsell link"
        corporateRef="ProfilePage-RenewUpsell"
      ></app-corporate-upsell-banner>
    </fl-bit>
  `,
  styleUrls: ['./user-profile-banner.component.scss'],
  animations: [
    trigger('showElement', [
      transition(':enter', [
        style({
          height: '0px',
          opacity: 0,
        }),
        animate('500ms ease-in', style({ opacity: 1, height: '100%' })),
      ]),
    ]),
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UserProfileBannerComponent implements OnInit {
  BannerId = BannerId;

  banner$: Rx.Observable<Banner>;
  hasCorporateDetails$: Rx.Observable<boolean>;
  status$: Rx.Observable<RequestStatus<BannersCollection>>;

  @Input()
  profileViewUsersDocument: DatastoreDocument<ProfileViewUsersCollection>;

  constructor(private datastore: Datastore) {}

  ngOnInit() {
    this.hasCorporateDetails$ = this.profileViewUsersDocument
      .valueChanges()
      .pipe(map(profileViewUser => !!profileViewUser.corporate));

    this.banner$ = this.datastore
      .collection<BannersCollection>('banners', query =>
        this.hasCorporateDetails$.pipe(
          map(hasCorporateDetails =>
            hasCorporateDetails
              ? query.where('type', '==', BannerType.USER_PROFILE)
              : query.null(),
          ),
        ),
      )
      .valueChanges()
      .pipe(map(banners => banners[0]));
  }
}
